// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"BackButton_buttonIcon__6yeLe","linkButton":"BackButton_linkButton__Lkk7e"};